export default "__VITE_ASSET__BNQhW3Gj__"